export function generateRequestId() {

    let requestId = '';
    for (let i = 0; i < 9; ++i) {
        requestId += Math.floor(Math.random() * 10);
    }

    return requestId;
}